import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const actionType = {
	SetChangePass: '[CHANGEPASS]',
};

export const initialChangePassword = {
	changePassword: false,
};

const initialState = {
	changePassword: false,
};

export const reducer = persistReducer(
	{ storage, key: 'changePassword', whitelist: ['changePassword'] },
	(state = initialState, action) => {
		switch (action.type) {
			case actionType.SetChangePass:
				return { ...state, changePassword: action.payload };

			default:
				return state;
		}
	}
);

export const actions = {
	SetChangePass: (data) => ({
		type: actionType.SetChangePass,
		payload: data,
	}),
};
